import React from 'react';

function Footer({ lang }) {
  const year = new Date().getFullYear();
  const isEn = lang === 'en';

  return (
    <footer className="app-footer">
      <p className="app-footer-copy">
        © {year} Aevdir. {isEn ? 'All rights reserved.' : '保留所有权利。'}
      </p>
    </footer>
  );
}

export default Footer;
